export const ADDRESS_FORM_CONFIG = [
  {
    section: "Contact Details",
    fields: [
      {
        key: "name",
        label: "Name",
        type: "INPUT",
        required: true
      },
      {
        key: "phoneNumber",
        label: "Phone No",
        type: "INPUT",
        required: true,
        disabled: true,
        disabledHint: (ctx) =>
          `Cannot edit phone number (${ctx?.formData?.phoneNumber})`
        // otp: { send: "sendPhoneOTP", verify: "verifyPhoneOTP" }
      },
      {
        key: "email",
        label: "Email",
        type: "Input",
        required: true,
        disabled: (ctx) => !!ctx?.formData?.userDataEmail,
        disabledHint: (ctx) =>
          `Cannot edit Email, Please go to profile section to edit email (${ctx?.formData?.phoneNumber})`
      }
    ]
  },
  {
    section: "Address",
    fields: [
      { key: "pincode", label: "Pincode", type: "INPUT", required: true },
      { key: "areaLocation", label: "Flat No., Building Name & Area / Location", type: "INPUT", required: true },
      {
        key: "landmark",
        label: "Landmark",
        type: "INPUT",
        visibleIf: (ctx) => !!ctx.formData.areaLocation
      },
      { key: "city", label: "City", type: "INPUT", required: true },
      { key: "state", label: "State", type: "INPUT", required: true },
      { key: "default", label: "Make this default address", type: "CHECKBOX" }
    ]
  }
];
